export * from '@core/directives/long-press/long-press.directive';
export * from '@core/directives/long-press/long-press.module';
